import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=4e491470&scoped=true&"
import script from "./examine-detail.vue?vue&type=script&lang=js&"
export * from "./examine-detail.vue?vue&type=script&lang=js&"
import style0 from "./examine-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./examine-detail.vue?vue&type=style&index=1&id=4e491470&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e491470",
  null
  
)

export default component.exports